/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import * as _ from 'lodash';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useSelector, useDispatch } from 'react-redux';
import { branchProductHandler } from '../../redux/handlers';

const formatOptionItemsWithPricing = (itemList, optionId, branchData, relationField) => {
  if (!itemList || !Array.isArray(itemList)) return [];

  return itemList.map(option => {
    let itemPrice = option.price || 0;
    let isVisible = true;
    let itemId = option.id;

    if (branchData && branchData[relationField]) {
      const matchingOption = branchData[relationField].find(bo => {
        if (relationField === 'product_specific_option_relation') {
          return bo.product_specific_option_id === optionId && bo.product_specific_option_item_id === option.id;
        }
        return (
          bo.product_option_id === optionId && (bo.product_option_item_id === option.id || option.name === bo.name)
        );
      });

      if (matchingOption) {
        itemPrice = matchingOption.price || itemPrice;
        isVisible = matchingOption.is_show !== false;
      }
    }

    return {
      itemId: itemId || String(Math.random()).substring(2, 10),
      itemName: option.name,
      itemPrice: itemPrice,
      isVisible: isVisible,
      originalItemId: option.id
    };
  });
};

const BundleItemsSection = ({ bundleItems }) => {
  if (!bundleItems?.length) return null;

  return (
    <div className="mb-3">
      <div className="fs-18 fw-5 tc-2 mb-3">รายการสินค้าในชุด</div>
      <div>
        {bundleItems.map((item) => (
          <div
            className="form-check form-check-inline form-check-st-2 mb-3"
            key={item.id}
          >
            <input
              className="form-check-input form-option"
              type="checkbox"
              checked={true}
              disabled={true}
              onChange={() => {}}
            />
            <label className="form-check-label ms-2 ps-1 mt-1 text-muted">
              {item.componentProduct?.name}
              {item.quantity > 1 && (
                <span className="ms-1">x{item.quantity}</span>
              )}
            </label>
          </div>
        ))}
      </div>
      <hr style={{ margin: '1rem 0' }} />
    </div>
  );
};

const SingleSelectionOptionGroup = ({
  optionCategory,
  selectedOptionsState,
  addSelectedOption,
  removeSelectedOption,
  isDisabled
}) => {
  return (
    <div className="mb-3">
      <div className="fs-18 fw-5 tc-2 mb-3">
        {optionCategory.optionName} <span className="fs-14 fw-light tc-16 ms-2">(เลือกได้ 1 อย่าง)</span>
      </div>
      <div>
        {optionCategory.optionList?.map((option, index) => (
          <div
            className="form-check form-check-inline form-check-st-2 mb-3"
            key={`${optionCategory.optionID}-${index}`}
          >
            <input
              className="form-check-input form-option"
              type="checkbox"
              name={optionCategory.optionID}
              id={`option-${optionCategory.optionID}-${option.itemId}`}
              checked={selectedOptionsState.optionChecked.some(o => o.itemId === option.itemId)}
              onChange={e => {
                if (e.target.checked && !isDisabled) {
                  addSelectedOption({
                    ...option,
                    categoryID: optionCategory.optionID,
                    categoryName: optionCategory.optionName
                  });
                } else {
                  removeSelectedOption(option.itemId);
                }
              }}
              disabled={isDisabled}
            />
            <label
              className={`form-check-label  ms-2 ps-1 mt-1 ${isDisabled ? 'text-muted' : ''}`}
              htmlFor={`option-${optionCategory.optionID}-${option.itemId}`}
            >
              {option.itemName}
              {option.itemPrice > 0 && <span className="ms-1">(+{parseFloat(option.itemPrice).toFixed(2)})</span>}
            </label>
          </div>
        ))}
      </div>
      <hr style={{ margin: '1rem 0' }} />
    </div>
  );
};

const MultiSelectionOptionGroup = ({
  optionCategory,
  selectedOptionsState,
  orderQuantityData,
  addSelectedOption,
  removeSelectedOption,
  updateOptionQuantity,
  isDisabled
}) => {
  const getOptionQuantity = itemId => {
    if (!orderQuantityData || !orderQuantityData.productOrder || !Array.isArray(orderQuantityData.productOrder)) {
      return 1;
    }

    const foundItem = orderQuantityData.productOrder.find(el => el.itemId === itemId);
    return foundItem ? foundItem.optionQty ?? 1 : 1;
  };

  return (
    <div className="mb-3">
      <div className="fs-18 fw-5 tc-2 mb-3">
        {optionCategory.optionName} <span className="fs-14 fw-light tc-16 ms-2">(เลือกมากกว่า 1 อย่าง)</span>
      </div>
      <div className="card card-option">
        <div className="card-body pe-5">
          <div className="row gx-5 gy-2">
            {(optionCategory.optionList || []).map((option, index) => {
              const isChecked =
                Array.isArray(selectedOptionsState.optionChecked) &&
                selectedOptionsState.optionChecked.some(o => o.itemId === option.itemId);
              const quantity = getOptionQuantity(option.itemId);
              const totalPrice = parseFloat(option.itemPrice || 0) * quantity;

              return (
                <div className="col-6" key={index}>
                  <div className="form-check form-check-group form-check-st-2 t0 d-flex align-items-center">
                    <input
                      className="form-check-input form-option"
                      type="checkbox"
                      checked={isChecked}
                      onChange={e => {
                        if (!isDisabled) {
                          if (e.target.checked) {
                            addSelectedOption({
                              ...option,
                              optionQty: 1,
                              categoryID: optionCategory.optionID,
                              categoryName: optionCategory.optionName
                            });
                          } else {
                            removeSelectedOption(option.itemId);
                          }
                        }
                      }}
                      disabled={isDisabled}
                    />
                    <input
                      type="text"
                      name="optionQty"
                      className="form-control validateNumber form-option-number mx-3"
                      value={quantity}
                      onChange={e => {
                        if (!isDisabled) {
                          const value = e.target.value;

                          if (value === '' || /^\d+$/.test(value)) {
                            if (value === '') {
                              updateOptionQuantity(option.itemId, 0);
                            } else {
                              const parsedValue = parseInt(value, 10);
                              if (parsedValue <= 99) {
                                updateOptionQuantity(option.itemId, parsedValue);
                              } else {
                                updateOptionQuantity(option.itemId, 99);
                                e.target.value = '99';
                              }
                            }
                          }
                        }
                      }}
                      disabled={isDisabled}
                    />

                    <div className={`me-auto ${isDisabled ? 'text-muted' : ''}`}>{option.itemName}</div>
                    <div className={isDisabled ? 'text-muted' : ''}>X {totalPrice.toFixed(2)}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <hr style={{ margin: '1rem 0' }} />
    </div>
  );
};

export default function ProductOrderConfigurationModal(props) {
  const {
    productselect,
    productOrder,
    setProductOrder,
    addProductOrders,
    businessSlug,
    removeProductOrders,
    edit,
    onHide,
    show,
    ...rest
  } = props;

  const dispatch = useDispatch();
  const loading = useSelector(state => state.common.loading);
  const [maxAllowedQuantity, setMaxAllowedQuantity] = useState(99);
  const [originalQty, setOriginalQty] = useState(1);
  const [currentProductDetails, setCurrentProductDetails] = useState({});
  const calculationInProgress = useRef(false);
  const skipOptionUpdate = useRef(false);
  const debouncedPriceUpdate = useRef(null);
  const isSubmitting = useRef(false);

  const branchProductData = useSelector(state => state.branchProduct?.data);

  const isDisabled =
    productOrder.productStatus === 1 ||
    productOrder.productStatus === 2 ||
    productOrder.productStatus === 3 ||
    productOrder.productStatus === 4;

  const isDisabledQty = productOrder.productStatus === 2 || productOrder.productStatus === 4;

  const calculateOptionsSubtotal = useCallback(options => {
    if (!options?.length) return 0;

    let total = 0;
    for (const option of options) {
      let itemPrice = 0;
      if (option.itemPrice !== undefined && option.itemPrice !== null) {
        itemPrice = Number(parseFloat(option.itemPrice));
      }

      let optionQty = 1;
      if (option.optionQty !== undefined && option.optionQty !== null) {
        optionQty = Number(parseInt(option.optionQty, 10));
        if (isNaN(optionQty) || optionQty < 1) optionQty = 1;
      }

      if (!isNaN(itemPrice)) {
        total += itemPrice * optionQty;
      }
    }

    return total;
  }, []);

  const calculateTotalPrice = useCallback(
    product => {
      const basePrice = product.productPrice ? parseFloat(product.productPrice) : 0;
      const standardOptionsSubtotal = calculateOptionsSubtotal(product.standardOptions || []);
      const specificOptionsSubtotal = calculateOptionsSubtotal(product.specificOptions || []);

      const unitPrice = basePrice + standardOptionsSubtotal + specificOptionsSubtotal;
      const productQty = parseInt(product.productQty || 1);
      const finalTotal = unitPrice * productQty;

      return {
        unitPrice,
        finalTotal,
        displayPrice: isNaN(finalTotal) ? '0.00' : finalTotal.toFixed(2)
      };
    },
    [calculateOptionsSubtotal]
  );

  const updateTotalPrice = useCallback(() => {
    if (calculationInProgress.current) return;

    calculationInProgress.current = true;
    const { finalTotal, displayPrice } = calculateTotalPrice(productOrder);

    setProductOrder(prev => {
      if (Math.abs(prev.productSumPrice - finalTotal) < 0.001 && prev.displayPrice === displayPrice) {
        calculationInProgress.current = false;
        return prev;
      }

      calculationInProgress.current = false;
      return {
        ...prev,
        productSumPrice: isNaN(finalTotal) ? 0 : finalTotal,
        displayPrice
      };
    });
  }, [productOrder, calculateTotalPrice, setProductOrder]);

  useEffect(() => {
    debouncedPriceUpdate.current = _.debounce(() => {
      if (!calculationInProgress.current) {
        updateTotalPrice();
      }
    }, 150);

    return () => {
      if (debouncedPriceUpdate.current) {
        debouncedPriceUpdate.current.cancel();
      }
    };
  }, [updateTotalPrice]);

  const formatStandardOptionsFromProduct = useCallback((product, branchData) => {
    if (!product?.productSpecificOptionRelation) return [];

    return product.productSpecificOptionRelation.map(item => {
      const visibleOptions = formatOptionItemsWithPricing(
        item.productSpecificOptionItem || [],
        item.id,
        branchData,
        'product_specific_option_relation'
      );

      return {
        optionID: item.id,
        optionName: item.name,
        selecttype: 0,
        optionList: visibleOptions
      };
    });
  }, []);

  const formatSpecificOptionsFromBranch = useCallback((product, branchData) => {
    if (!product?.productOptionRelation) return [];

    return product.productOptionRelation.map(relation => {
      const item = relation.productOption;

      const visibleOptions = formatOptionItemsWithPricing(
        item.productOptionItem || [],
        item.id,
        branchData,
        'product_option_relation'
      );

      return {
        optionID: item.id,
        optionName: item.name,
        selecttype: item.is_multiple_select ? 1 : 0,
        is_multiple_select: item.is_multiple_select,
        optionList: visibleOptions
      };
    });
  }, []);

  const formatAnnotationOptionsFromProduct = useCallback(product => {
    if (!product?.productAnnotationRelation) return [];

    const allAnnotationItems = [];

    product.productAnnotationRelation.forEach(relation => {
      const item = relation.productAnnotation;

      if (item.productAnnotationItem && item.productAnnotationItem.length > 0) {
        item.productAnnotationItem.forEach(option => {
          allAnnotationItems.push({
            itemId: option.id,
            originalItemId: option.id,
            itemName: option.name,
            itemPrice: 0,
            isVisible: true,
            categoryID: item.id,
            categoryName: item.name
          });
        });
      } else {
        allAnnotationItems.push({
          itemId: item.id,
          originalItemId: item.id,
          itemName: item.name,
          itemPrice: 0,
          isVisible: item.is_display !== false,
          categoryID: item.id,
          categoryName: item.name
        });
      }
    });

    const visibleAnnotationItems = allAnnotationItems.filter(item => item.isVisible);

    return [
      {
        optionID: 'combined-annotations',
        optionName: 'ตัวเลือกหมายเหตุ',
        selecttype: 1,
        is_multiple_select: true,
        optionList: visibleAnnotationItems
      }
    ];
  }, []);

  const addSelectedOption = useCallback(
    (optionType, item) => {
      if (isDisabled || skipOptionUpdate.current) return;

      skipOptionUpdate.current = true;
      setProductOrder(prev => {
        const currentOptions = prev[optionType] || [];
        let newOptions;

        if (optionType === 'standardOptions') {
          const category = currentProductDetails.standardOptions?.find(option => option.optionID === item.categoryID);

          if (category && category.selecttype === 0) {
            newOptions = currentOptions.filter(option => option.categoryID !== item.categoryID);

            newOptions.push({
              ...item,
              originalItemId: item.originalItemId
            });
          } else {
            if (!currentOptions.some(o => o.itemId === item.itemId)) {
              newOptions = [
                ...currentOptions,
                {
                  ...item,
                  originalItemId: item.originalItemId
                }
              ];
            } else {
              newOptions = currentOptions;
            }
          }
        } else if (optionType === 'specificOptions') {
          const category = currentProductDetails.specificOptions?.find(option => option.optionID === item.categoryID);

          if (category && !category.is_multiple_select) {
            newOptions = currentOptions.filter(option => option.categoryID !== item.categoryID);

            newOptions.push({
              ...item,
              originalItemId: item.originalItemId
            });
          } else {
            if (!currentOptions.some(o => o.itemId === item.itemId)) {
              newOptions = [
                ...currentOptions,
                {
                  ...item,
                  originalItemId: item.originalItemId
                }
              ];
            } else {
              newOptions = currentOptions;
            }
          }
        } else {
          if (!currentOptions.some(o => o.itemId === item.itemId)) {
            newOptions = [
              ...currentOptions,
              {
                ...item,
                originalItemId: item.originalItemId
              }
            ];
          } else {
            newOptions = currentOptions;
          }
        }

        return {
          ...prev,
          [optionType]: newOptions
        };
      });

      setTimeout(() => {
        skipOptionUpdate.current = false;
        if (debouncedPriceUpdate.current) {
          debouncedPriceUpdate.current();
        }
      }, 0);
    },
    [isDisabled, currentProductDetails]
  );

  const removeSelectedOption = useCallback(
    (optionType, id) => {
      if (isDisabled || skipOptionUpdate.current) return;

      skipOptionUpdate.current = true;
      setProductOrder(prev => {
        const newOptions = prev[optionType]?.filter(o => o.itemId !== id) || [];

        return {
          ...prev,
          [optionType]: newOptions
        };
      });

      setTimeout(() => {
        skipOptionUpdate.current = false;
        if (debouncedPriceUpdate.current) {
          debouncedPriceUpdate.current();
        }
      }, 0);
    },
    [isDisabled]
  );

  const updateOptionQuantity = useCallback(
    (optionType, id, value) => {
      if (isDisabled || skipOptionUpdate.current) return;

      skipOptionUpdate.current = true;
      setProductOrder(prev => {
        const newOptions =
          prev[optionType]?.map(el =>
            el.itemId === id
              ? {
                  ...el,
                  optionQty: value
                }
              : el
          ) || [];

        return {
          ...prev,
          [optionType]: newOptions
        };
      });

      setTimeout(() => {
        skipOptionUpdate.current = false;
        if (debouncedPriceUpdate.current) {
          debouncedPriceUpdate.current();
        }
      }, 0);
    },
    [isDisabled]
  );

  const handleSubmit = useCallback(
    event => {
      event.preventDefault();
      event.stopPropagation();
      addProductOrders();
    },
    [addProductOrders]
  );

  const getProductStatusInfo = useCallback(status => {
    switch (status) {
      case 0:
        return { text: '', class: '' };
      case 1:
        return { text: 'ยกเลิกรายการ', class: '' };
      case 2:
        return { text: 'รายการสำเร็จ', class: 'text-success' };
      case 3:
        return { text: 'รายการถูกยกเลิกโดยครัว', class: 'text-danger' };
      case 4:
        return { text: 'รายการถูกยกเลิก', class: 'text-danger' };
      default:
        return { text: '', class: '' };
    }
  }, []);

  useEffect(() => {
    if (productselect?.id !== undefined && show) {
      const branchId = localStorage.getItem('branchId');
      dispatch(branchProductHandler.getBranchProduct(businessSlug, productselect.id, branchId));
    }
  }, [dispatch, productselect?.id, businessSlug, show]);

  useEffect(() => {
    if (show) {
      setMaxAllowedQuantity(99);

      setOriginalQty(parseInt(productOrder.productQty) || 1);
    }
  }, [show]);

  useEffect(() => {
    if (!branchProductData?.product) {
      if (productselect && Object.keys(productselect).length > 0) {
        setCurrentProductDetails(productselect);
      }
      return;
    }

    const product = branchProductData.product;
    const productData = branchProductData.data;
    const branchData = branchProductData.data || {};
    const orders = props.orders || {};

    const standardOptions = formatStandardOptionsFromProduct(product, branchData);
    const specificOptions = formatSpecificOptionsFromBranch(product, branchData);
    const annotationOptions = formatAnnotationOptionsFromProduct(product);
    const bundleItems = product.productBundleItemsAsBundle?.filter(item => item.is_active) || [];

    const useDeliveryPrice = orders.delivery === 3;

    const productPrice = useDeliveryPrice
      ? parseFloat(productData.price_delivery || product.price_delivery)
      : productData.price || product.price || productselect.productPrice || 0;

    setCurrentProductDetails(prevDetails => {
      if (
        _.isEqual(prevDetails.standardOptions, standardOptions) &&
        _.isEqual(prevDetails.specificOptions, specificOptions) &&
        _.isEqual(prevDetails.annotationOptions, annotationOptions) &&
        _.isEqual(prevDetails.bundleItems, bundleItems) &&
        prevDetails.productPrice === productPrice
      ) {
        return prevDetails;
      }

      return {
        ...prevDetails,
        ...productselect,
        productPrice,
        standardOptions,
        specificOptions,
        annotationOptions,
        bundleItems
      };
    });

    setProductOrder(prevOrder => {
      if (prevOrder.productPrice === productPrice) {
        return prevOrder;
      }
      return {
        ...prevOrder,
        productPrice
      };
    });
  }, [
    branchProductData,
    productselect,
    formatStandardOptionsFromProduct,
    formatSpecificOptionsFromBranch,
    formatAnnotationOptionsFromProduct,
    props.orders
  ]);

  useEffect(() => {
    if (calculationInProgress.current || skipOptionUpdate.current) return;

    if (debouncedPriceUpdate.current) {
      debouncedPriceUpdate.current();
    }
  }, [productOrder.productQty, productOrder.productPrice, productOrder.standardOptions, productOrder.specificOptions]);

  useEffect(() => {
    if (show && !calculationInProgress.current) {
      updateTotalPrice();
    }
  }, [show, updateTotalPrice]);

  const statusInfo = getProductStatusInfo(productOrder.productStatus);

  return (
    <Modal
      {...rest}
      size="lg"
      centered
      dialogClassName="modal-st-1 optionModal"
      show={show && !loading}
      onHide={onHide}
      backdrop={true}
    >
      <Form noValidate onSubmit={handleSubmit}>
        <div className="modal-header px-4">
          <div className="fs-18 fw-6 tc-2 me-auto foodName">
            {statusInfo.text && <span className={`me-3 ${statusInfo.class}`}>{statusInfo.text}</span>}
            {currentProductDetails?.productName}
          </div>

          <div className={`me-4 ${props.orders.delivery === 3 ? 'w-[10vw]' : ''}`}>
            <span className="fw-light tc-2 fs-16 me-2">{props.orders.delivery === 3 ? 'ราคาเดลิเวอรี่' : 'ราคา'}</span>
            <span className="fw-18 fw-6">
              <span className="foodPrice">{productOrder.displayPrice}</span>
              .-
            </span>
          </div>

          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn btn-minus"
              disabled={parseInt(productOrder.productQty) <= 1 || isDisabledQty}
              onClick={() => {
                if (isDisabledQty) return;

                setProductOrder(prev => {
                  const newQty = Math.max(1, parseInt(prev.productQty) - 1);
                  if (newQty === parseInt(prev.productQty)) return prev;

                  return {
                    ...prev,
                    productQty: newQty
                  };
                });
              }}
            ></button>
            <input
              type="text"
              name="foodQty"
              className="form-control mx-4 text-center lh-1 foodQty"
              value={productOrder.productQty}
              onChange={e => {
                if (isDisabledQty) return;

                const value = e.target.value;

                if (value === '' || /^\d+$/.test(value)) {
                  if (value === '') {
                    setProductOrder(prev => ({
                      ...prev,
                      productQty: 1
                    }));
                  } else {
                    const parsedValue = parseInt(value, 10);

                    const effectiveMax =
                      productOrder.productStatus !== 0 ? Math.min(originalQty, 99) : Math.min(maxAllowedQuantity, 99);

                    if (parsedValue <= effectiveMax) {
                      const validQty = Math.max(1, parsedValue);
                      setProductOrder(prev => {
                        if (prev.productQty === validQty) return prev;
                        return {
                          ...prev,
                          productQty: validQty
                        };
                      });
                    } else {
                      setProductOrder(prev => {
                        if (prev.productQty === effectiveMax) return prev;
                        return {
                          ...prev,
                          productQty: effectiveMax
                        };
                      });
                      e.target.value = effectiveMax.toString();
                    }
                  }
                }
              }}
              disabled={isDisabledQty}
            />
            <button
              type="button"
              className="btn btn-plus"
              onClick={() => {
                if (isDisabledQty) return;

                setProductOrder(prev => {
                  const currentQty = parseInt(prev.productQty);
                  const maxQty = productOrder.productStatus !== 0 ? originalQty : maxAllowedQuantity;
                  const newQty = Math.min(maxQty, currentQty + 1);

                  if (newQty === currentQty) return prev;

                  return {
                    ...prev,
                    productQty: newQty
                  };
                });
              }}
              disabled={
                parseInt(productOrder.productQty) >=
                  (productOrder.productStatus !== 0 ? originalQty : maxAllowedQuantity) || isDisabledQty
              }
            ></button>
          </div>
        </div>

        <div className="modal-body px-4 py-3">
          <div className="foodOption">
            <BundleItemsSection bundleItems={currentProductDetails?.bundleItems} />

            {currentProductDetails?.standardOptions?.map((optionCategory, index) =>
              optionCategory.selecttype === 0 ? (
                <SingleSelectionOptionGroup
                  key={`standard-${index}`}
                  optionCategory={optionCategory}
                  selectedOptionsState={{
                    option: currentProductDetails.standardOptions,
                    optionChecked: productOrder.standardOptions || []
                  }}
                  addSelectedOption={item => addSelectedOption('standardOptions', item)}
                  removeSelectedOption={id => removeSelectedOption('standardOptions', id)}
                  isDisabled={isDisabled}
                />
              ) : (
                <MultiSelectionOptionGroup
                  key={`standard-multi-${index}`}
                  optionCategory={optionCategory}
                  selectedOptionsState={{
                    option: currentProductDetails.standardOptions,
                    optionChecked: productOrder.standardOptions || []
                  }}
                  orderQuantityData={{
                    productOrder: productOrder.standardOptions || []
                  }}
                  addSelectedOption={item => addSelectedOption('standardOptions', item)}
                  removeSelectedOption={id => removeSelectedOption('standardOptions', id)}
                  updateOptionQuantity={(id, value) => updateOptionQuantity('standardOptions', id, value)}
                  isDisabled={isDisabled}
                />
              )
            )}

            {currentProductDetails?.specificOptions?.map((optionCategory, index) =>
              !optionCategory.is_multiple_select ? (
                <SingleSelectionOptionGroup
                  key={`specific-${index}`}
                  optionCategory={optionCategory}
                  selectedOptionsState={{
                    option: currentProductDetails.specificOptions,
                    optionChecked: productOrder.specificOptions || []
                  }}
                  addSelectedOption={item => addSelectedOption('specificOptions', item)}
                  removeSelectedOption={id => removeSelectedOption('specificOptions', id)}
                  isDisabled={isDisabled}
                />
              ) : (
                <MultiSelectionOptionGroup
                  key={`specific-multi-${index}`}
                  optionCategory={optionCategory}
                  selectedOptionsState={{
                    option: currentProductDetails.specificOptions,
                    optionChecked: productOrder.specificOptions || []
                  }}
                  orderQuantityData={{
                    productOrder: productOrder.specificOptions || []
                  }}
                  addSelectedOption={item => addSelectedOption('specificOptions', item)}
                  removeSelectedOption={id => removeSelectedOption('specificOptions', id)}
                  updateOptionQuantity={(id, value) => updateOptionQuantity('specificOptions', id, value)}
                  isDisabled={isDisabled}
                />
              )
            )}
          </div>

          <div className="pe-4">
            <div className="row gx-5">
              <div className="col-6">
                <div className="d-flex align-items-center mb-1">
                  <div className="me-auto fs-14 tc-15">หมายเหตุ</div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-link p-0 text-danger btn-clear fs-14"
                      onClick={() => {
                        if (!isDisabled) {
                          setProductOrder(prev => ({ ...prev, note: '' }));
                        }
                      }}
                      disabled={isDisabled}
                    >
                      ล้าง
                    </button>
                  </div>
                </div>
                <textarea
                  className="form-control fs-14"
                  name="foodNote"
                  rows="4"
                  onChange={e => {
                    if (!isDisabled) {
                      setProductOrder(prev => {
                        if (prev.note === e.target.value) return prev;
                        return {
                          ...prev,
                          note: e.target.value
                        };
                      });
                    }
                  }}
                  value={productOrder.note || ''}
                  disabled={isDisabled}
                ></textarea>
              </div>

              <div className="col-6">
                {currentProductDetails?.annotationOptions?.length > 0 && (
                  <div className="fs-14 tc-15 mb-2">ตัวเลือกหมายเหตุ</div>
                )}

                <div className="d-flex flex-wrap">
                  {currentProductDetails?.annotationOptions?.[0]?.optionList?.map(item => {
                    const isChecked = (productOrder.annotationOptions || []).some(o => o.itemId === item.itemId);

                    return (
                      <div className="form-check-option me-2 mb-2" key={`note-${item.categoryID}-${item.itemId}`}>
                        <input
                          type="checkbox"
                          name={`annotationOptions-${item.categoryID}`}
                          className="hide-input"
                          id={`annotationOptions-${item.categoryID}-${item.itemId}`}
                          checked={isChecked}
                          onChange={e => {
                            if (!isDisabled) {
                              if (e.target.checked) {
                                addSelectedOption('annotationOptions', {
                                  ...item,
                                  categoryID: item.categoryID,
                                  categoryName: item.categoryName
                                });
                              } else {
                                removeSelectedOption('annotationOptions', item.itemId);
                              }
                            }
                          }}
                          disabled={isDisabled}
                        />
                        <label
                          htmlFor={`annotationOptions-${item.categoryID}-${item.itemId}`}
                          className={isDisabled ? 'text-muted' : ''}
                        >
                          {item.itemName}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr style={{ margin: '1rem 0' }} />

        <div className="text-end d-flex align-items-center px-4 pb-2 mb-2">
          <div className="me-auto">
            {edit === 1 && productOrder.productStatus !== 4 && (
              <button
                type="button"
                className="btn btn-st-9 px-4 py-3 lh-1 btn-cancel-food"
                onClick={() => {
                  removeProductOrders(productOrder);
                }}
              >
                ยกเลิกรายการ
              </button>
            )}
          </div>
          <button type="button" className="btn btn-st-2 px-5 py-3 lh-1 me-3" onClick={onHide}>
            ยกเลิก
          </button>
          <button
            className="btn btn-login px-5 py-3 lh-1"
            disabled={productOrder.productStatus === 4 || isSubmitting.current}
            onClick={() => {
              if (!isSubmitting.current) {
                isSubmitting.current = true;
                addProductOrders();
                setTimeout(() => {
                  isSubmitting.current = false;
                }, 100);
              }
            }}
          >
            ยืนยัน
          </button>
        </div>
      </Form>
    </Modal>
  );
}
